import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {Object}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing a drivings events icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <DrivingEventsIcon width={12} />
 */
const DrivingEventsIcon = props => (
    <SvgIcon viewBox="0 0 48 48" {...props}>
        <path
            d={`M45.3,39.3l-8.5-14.8C35.9,22.9,34.5,22,33,22s-2.9,0.9-3.8,2.5l-8.5,14.7c-0.9,1.4-0.9,
            3.2-0.1,4.6 c0.9,1.4,2.5,2.2,4.2,2.1h16.5c1.8,0,3.4-0.8,4.2-2.1C46.2,42.4,46.2,40.7,45.3,39.3z
            M33,43.8c-1.3,0-2.3-1-2.3-2.3 c0-1.3,1-2.3,2.3-2.3c1.3,0,2.3,1,2.3,2.3l0,0C35.3,42.7,34.3,43.8,
            33,43.8z M34.7,36.1c0,0.9-0.8,1.6-1.7,1.6c0,0,0,0,0,0 c-0.9,0.1-1.7-0.6-1.7-1.5c0,0,0,0,0,
            0c-0.1-0.9-0.6-7.5-0.6-7.5c0.1-1.2,1.1-2.1,2.3-2.1c0,0,0,0,0,0c1.2-0.1,2.2,0.9,2.3,2.1
            C35.3,28.7,34.8,35.2,34.7,36.1z`}
        />
        <path
            d={`M12.2,32.7l10.1-4.3l2.8-4.9l-10.4,4.4c-0.4,0.2-0.9,0-1.1-0.5c-0.2-0.4,
            0-0.9,0.5-1.1l11-4.6c0.4-0.2,0.8,0,1,0.3c0.8-1.3,1.9-2.3,3.2-3c-0.5-0.3-1-0.7-1.2-1.3c-0.5-1.3,0.1-2.8,
            1.4-3.4s2.8,0.1,3.3,1.4c0.3,0.8,0.2,1.7-0.2,2.3 c0.2,0,0.3,0,0.5,0c0.9,0,1.9,0.2,2.7,0.5L34,
            14.2c-0.7-1.8-2.3-3.6-3.5-4.1L29,9.5c-0.5-0.2-1-0.6-1.3-1l-4.2-5 c-1.4-1.5-3.5-2-5.4-1.3L5.6,
            7.6c-1.8,0.9-2.9,2.7-2.9,4.7l0.5,6.6c0,0.6-0.1,1.1-0.3,1.7L2.3,22c-0.5,1.2-0.3,3.7,0.4,5.4l3.9,
            9.5 c0.4,0.9,1.3,1.3,2.2,0.9l3.1-1.3c0.9-0.4,1.3-1.4,0.9-2.2L12.2,32.7z M7.9,28.9c-1.3,
            0.5-2.8-0.1-3.3-1.4c-0.5-1.3,0.1-2.8,1.4-3.4 c1.3-0.5,2.8,0.1,3.3,1.4C9.8,26.9,9.2,28.4,
            7.9,28.9z M5.6,18.7c-0.3,0.2-0.6,0-0.8-0.2c0-0.1-0.1-0.2-0.1-0.3l-0.4-6
            c0-1.3,0.7-2.5,1.8-3l12.5-5.3c1.2-0.4,2.5-0.1,3.4,0.8L26,9.3c0.2,0.2,0.2,
            0.6,0,0.8c-0.1,0.1-0.2,0.1-0.2,0.2L5.6,18.7z`}
        />
    </SvgIcon>
)

DrivingEventsIcon.defaultProps = defaultProps

export { DrivingEventsIcon }
